import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import visionImg from "../../assets/vision.webp";
import missionImg from "../../assets/_cq_featuredimage.uaimg.jpg";
import { FaEye, FaBullseye } from "react-icons/fa";

const VissionMission = () => {
  return (
    <div
      className="py-5"
      style={{
        background: "linear-gradient(to right, #e0ecff, #f5f8ff)",
        overflow: "hidden",
      }}
    >
      <Container>
        <h2 className="title-font mb-4 text-center" data-aos="flip-left">
          Our Vision & Mission
        </h2>

        <p
          className="text-center mx-auto mb-3"
          style={{ maxWidth: "900px" }}
          data-aos="flip-left"
        >
          EHSAS is not just a service; it's a transformation in how print
          infrastructure is managed and optimized. From real-time data and AMC
          planning to HR operations and ERP-based service solutions, our
          intelligent platform reduces downtime and improves decision-making for
          governments, corporates, and institutions.
        </p>

        <Row className="g-4">
          <Col md={6} data-aos-delay="100">
            <Card className="h-100 shadow-lg border-0 rounded-4 hover-shadow text-center p-3">
              <div className="position-relative">
                <div className="choose-img-wrapper w-100">
                  <img
                    src={visionImg}
                    alt="Vision"
                    className="img-fluid rounded-4 zoom-hover-img"
                    style={{
                      height: "220px",
                      objectFit: "cover",
                      width: "100%",
                    }}
                  />
                </div>
              </div>
              <Card.Body data-aos="zoom-in">
                <Card.Title className="fw-bold theme-font-color  mb-3 fs-4">
                  Our Vision
                </Card.Title>
                <Card.Text>
                  To revolutionize Managed Print Services across Africa and
                  beyond by delivering a fully automated, transparent, and
                  data-driven print management ecosystem that empowers
                  governments, businesses, and institutions to operate
                  efficiently and sustainably.
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>

          <Col md={6} data-aos-delay="200">
            <Card className="h-100 shadow-lg border-0 rounded-4 hover-shadow text-center p-3">
              <div className="position-relative">
                <div className="choose-img-wrapper w-100">
                  <img
                    src={missionImg}
                    alt="Vision"
                    className="img-fluid rounded-4  zoom-hover-img"
                    style={{
                      height: "220px",
                      objectFit: "cover",
                      width: "100%",
                    }}
                  />
                </div>
              </div>
              <Card.Body data-aos="zoom-in">
                <Card.Title className="fw-bold theme-font-color mb-3 fs-4">
                  Our Mission
                </Card.Title>
                <Card.Text>
                  To provide intelligent ERP-based print service solutions that
                  ensure uptime, accountability, and performance. To enable
                  real-time monitoring, predictive maintenance, and seamless
                  support through integrated mobile and web platforms. To build
                  long-term trust with clients by offering reliable, secure, and
                  innovative service delivery.
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default VissionMission;
